import { TennisMatchStatusType, LIVE, POSTPONED, ABANDONED, CANCELLED, PREMATCH } from '../../../typings/tennis-match';
import t from '../../../labels/labelling-utils';

const labelMap = {
  [LIVE]: t('tennis.match.status.live'),
  [POSTPONED]: t('tennis.match.status.postponed'),
  [ABANDONED]: t('tennis.match.status.abandoned'),
  [CANCELLED]: t('tennis.match.status.cancelled'),
  [PREMATCH]: t('tennis.match.status.scheduled'),
  default: t('tennis.match.status.fulltime'),
};

export const getLabel = (matchStatus: TennisMatchStatusType): string => {
  return labelMap[matchStatus] ?? labelMap.default;
};
